import api from './api';
import { setUserData } from './localSorage';

import { UserInterface } from '../interfaces/user';

export interface FetchAuthenticationResponse {
  data: {
    token: string;
    user: UserInterface;
  };
}

export const authenticate = async (
  username: string,
  password: string,
): Promise<{
  user: UserInterface;
  token: string;
}> => {
  const payload = {
    username,
    password,
  };
  const {
    data: { data },
  }: { data: FetchAuthenticationResponse } = await api.post('/login', payload);
  const { user, token } = data;

  setUserData(user, token);

  return data;
};
